import { ConfigTypes } from 'src/AppState/ConfigState/types';

export const features: ConfigTypes = {
    /* A */
    anniversaryInfoShow: false,
    accountTradingCountryClub: false,
    accountTradingDragonCircle: false,
    accountTradingRewardZone: false,
    accountTradingTartanClub: true,
    affiliateIdPromoCode: false,
    activityTimeframe: false,

    /* B */
    betBuilderReferralSwitchShow: true,

    /* C */
    casinoProviders: {
        casino: ['evolution', 'leap', 'pragmatic', 'sg-digital', 'relax', 'blueprint'],
        'live-casino': ['evolution', 'ezugi', 'pragmatic'],
        virtuals: ['leap'],
    },
    closureCodes: true,
    cmsHiddenTabs: ['headlineCarousel', 'promoCode'],
    complianceRestrictionSummary: true,
    contactPreferences: {
        preferences: ['email', 'sms', 'phone'],
        options: ['betting', 'casino'],
        newMarketing: true,
    },
    currencies: ['GBP', 'EUR', 'XTS'],
    cpfProperties: false,
    casinoStoreEnabled: false,

    /* D */
    dashboardTab: true,
    decimalLength: 2,
    depositLimitType: 'rollingType',
    depositLimitCalculationTypeConfigurable: true,
    depositRestriction: true,
    deceased: true,

    /* E */
    externalId: true,

    /* F */
    configurationManagerUI: false,
    failedWithdrawalsFundsEnabled: true,
    footerContentDefault: {
        description_text:
            '© McBookie All rights reserved. Star Racing Ltd (licence number {{licenceNumber}}) is licensed and regulated by the Gambling Commission. Star House, 255 Old Shoreham Road. Hove, East Sussex, BN3 7ED.',
        licence_number: '009177',
        licence_url: 'https://www.gamblingcommission.gov.uk/public-register/business/detail/009177',
        cookies_url: 'https://www.mcbookie.com/?account=static&static=cookie-policy',
        has_cookies: true,
    },
    footerLegalTextTab: true,
    fullNameProperties: false,

    /* H */
    hasNewMenu: true,
    hideDeleteImageButtonOnHomePageCarousel: false,
    hasXtremepush: false,

    /* G */
    gamprotect: false,
    gamstopNew: true,
    gamstopPpBlockedSuspendedActions: false,
    golfOnVirtuals: false,
    gtm: 'GTM-PZ8NL5R',

    /* I */
    isAffordability: true,
    isPEP: true,
    identity: true,
    idMission: false,
    isBoostedPriceAvailable: true,
    indexNow: null,

    /* L */
    languages: [
        {
            value: 'en',
            label: 'English',
        },
    ],

    /* O */
    operatorFullName: 'McBookie',

    /* P */
    personalId: false,
    paymentSearchWalletAddress: false,
    pof: true,
    promotionHistoryEnabled: true,

    /* R */
    realityCheckLimitedType: false,
    reportDownloadOptions: ['View', 'Download', 'Export to CSV'],
    redirectToNewBetTickerPage: false,
    redirectToNewCMSPage: false,
    reportsV2: false,
    redirectToNewTradingPage: false,
    showRingFencedFunds: true,

    /* M */
    markersOfHarm: true,
    mobilePrefixDisabled: false,
    dopplernegroPrefix: false,
    minDepositAmount: '1',
    minWithdrawAmount: '1',
    minManualAdjustmentAmount: '1',

    /* N */
    newPragmatic: true,
    newPofSrg: true,
    notificationSounds: {
        newChat: 'ding',
        newBetReferral: 'kaching',
    },

    /* S */
    sourceOfFunds: true,
    srgEnabled: true,
    starEventsLabel: 'Tartan Top-Ups',
    showBonusEngine: true,
    showNewCustomerSettings: false,
    showRABInputs: true,
    showBonusCreator: false,

    /* T */
    tableauDashboards: true,
    tagManagementTab: true,
    topEvents: false,

    /* U */
    useExtraPlacesForEvents: false,
    usePaymentFormForUniverse: {
        type: 'realex',
        openBanking: 'yaspa',
    },
    userTitleOptional: false,

    /* V */

    /* W */
    withdrawalsTabsShow: true,
    withdrawalStandardLimit: '5000',
    workbookView: {
        BackofficeReports: 'BackOfficeReports-McBookie/DB-Casino',
        CasinoDashboard: 'CasinoDashboard-McBookie/CasinoMainDashboard',
        ComplianceDashboard: 'ComplianceDashboard-McBookie/ComplianceMainDashboard',
        MarketingDashboard: 'MarketingDashboard-McBookie/MarketingMainDashboard',
        ProfitAndLossKPIs: 'ProfitandLossKPIs-McBookie/DailyKPI',
        RacecourseDashboard: 'Racecourse-McBookie/TheRacingPartnershipDashboard',
        TransactionsDashboard: 'TransactionsDashboard-McBookie/TransactionsMainDashboard',
        AccountBalances: 'AccountBalances-McBookie/AccountBalances',
        RollingNetDeposits: 'RollingNetDeposits-McBookie/RollingNetDeposits',

        PlatformOverview: 'Overview-McBookie/Overview',
        // TradingOverview: 'Trading-McBookie/Overview',
        // MarketingOverview: 'Marketing-McBookie/Overview',
        // PaymentsOverview: 'Payments-McBookie/Overview',

        BonusEngine: 'BonusEngine-McBookie/CampaignLevel',
    },
};
